import { forwardRef } from 'react';
import { StyledNav } from './styled';

const Nav = forwardRef((props, ref) => <StyledNav ref={ref} {...props} />);

export default Nav;
